import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/layout/ThemeProvider";
import { VarsProvider } from "@/state/vars";
import { Toaster } from "@/components/ui/sonner";
import { ConfirmProvider } from "@/components/common/Confirm";
import { AuthProvider } from "@/state/auth";
import { AuthGate } from "@/components/AuthGate";
import { queryClient } from "@/lib/invalidate";
import { router } from "@/router";
import "@/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <AuthGate>
            <VarsProvider>
              <TooltipProvider delayDuration={200}>
                <ConfirmProvider>
                  <RouterProvider router={router} />
                </ConfirmProvider>
                <Toaster />
              </TooltipProvider>
            </VarsProvider>
          </AuthGate>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
